@if (banners().length > 0) {
  <div class="flex flex-col">
    @for (banner of banners(); track banner.id) {
      <div
        class="animate-fade-down relative px-4 py-2.5 text-white shadow-md"
        [class.bg-gradient-to-r]="!banner.bannerColor"
        [class.from-blue-700]="!banner.bannerColor"
        [class.via-indigo-600]="!banner.bannerColor"
        [class.to-violet-600]="!banner.bannerColor"
        [class.cursor-pointer]="!!banner.linkUrl"
        [style.background-color]="banner.bannerColor || null"
        (click)="banner.linkUrl && openLink(banner.linkUrl)"
        role="alert">
        <div class="mx-auto flex max-w-7xl items-center justify-between text-xs sm:text-sm">
          <div class="flex-1 text-center font-medium">
            @if (banner.imageUrl) {
              <img
                [src]="banner.imageUrl"
                [alt]="banner.title"
                class="mr-2 inline-block h-5 w-5 rounded object-cover align-middle" />
            }
            <span>{{ banner.body }}</span>
          </div>
          <button
            (click)="$event.stopPropagation(); dismiss(banner.id, true)"
            class="ml-4 shrink-0 whitespace-nowrap text-[11px] underline decoration-white/40 transition-colors hover:decoration-white sm:text-xs"
            type="button">
            não mostrar novamente
          </button>
          <button
            (click)="$event.stopPropagation(); dismiss(banner.id)"
            class="ml-3 rounded-md p-1 transition-colors hover:bg-white/10"
            aria-label="Fechar banner">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    }
  </div>
}

@if (activePopup(); as popup) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
    <dialog
      open
      class="relative w-full max-w-lg rounded-2xl bg-white p-0 shadow-xl dark:bg-slate-900"
      [attr.aria-label]="popup.title">
      <button
        (click)="dismiss(popup.id)"
        class="absolute right-3 top-3 rounded-md p-1.5 text-slate-400 transition-colors hover:text-slate-600 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-500 dark:hover:text-slate-300"
        aria-label="Fechar">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd" />
        </svg>
      </button>

      @if (popup.imageUrl) {
        <img [src]="popup.imageUrl" [alt]="popup.title" class="max-h-[300px] w-full rounded-t-2xl object-cover" />
      }

      <div class="flex flex-col gap-2 p-5">
        @if (popup.title || popup.body) {
          <div class="mb-1">
            @if (popup.title) {
              <h2 class="text-base font-semibold text-slate-900 dark:text-white">{{ popup.title }}</h2>
            }
            @if (popup.body) {
              <p class="mt-1.5 text-sm text-slate-500 dark:text-slate-400">{{ popup.body }}</p>
            }
          </div>
        }

        @if (popup.linkUrl; as linkUrl) {
          <button
            (click)="openLink(linkUrl); dismiss(popup.id)"
            class="rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-500">
            Saiba mais
          </button>
          <button
            (click)="dismiss(popup.id)"
            class="rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-50 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-500 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800">
            Agora não
          </button>
        } @else {
          <button
            (click)="dismiss(popup.id)"
            class="rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-500">
            Entendido
          </button>
        }

        <button
          (click)="dismiss(popup.id, true)"
          class="text-xs text-slate-400 underline decoration-slate-300 transition-colors hover:text-slate-600 dark:decoration-slate-600 dark:hover:text-slate-300"
          type="button">
          não mostrar novamente
        </button>
      </div>
    </dialog>
  </div>
}
